import React from 'react'
import './Overview.scss'

const Overview: React.FC = () => {
  return (
    <div className="overview">
      <div className="overview__header">
        <h1 className="overview__title">Übersicht</h1>
      </div>
    </div>
  )
}

export default Overview